/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cron_HourlyInputs */

const cs_cron_hourly = /** @type {(inputs: Cron_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každou hodinu`)
};

const en_cron_hourly = /** @type {(inputs: Cron_HourlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every hour`)
};

/**
* | output |
* | --- |
* | "Every hour" |
*
* @param {Cron_HourlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const cron_hourly = /** @type {((inputs?: Cron_HourlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cron_HourlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cron_hourly(inputs)
	return cs_cron_hourly(inputs)
});